module.exports = __webpack_public_path__ + "static/media/Owen Lars.fb238258.jpg";